import React, { useEffect } from "react";
import logo from "./logo.svg";
import "./App.css";
import Slider from "./slider";
import FPSMeter from "./FPSCounter";
import ScreenDetails from "./screen-details/screen-details";

const OuterRadius = 11.5;
const InnerRadius = 6.5;
const buffersize = 0.0;

const Drop = 10;

const BlockDropDeg = 360 / (Drop * 2);
const ScaleFactor = 512 / (OuterRadius * 2 + 2);

const centerPoint = OuterRadius;

function App() {
  const [gamepads, setGamepads] = React.useState<(Gamepad | null)[]>([]);
  const [mediaDevices, setMediaDevices] = React.useState<
    (MediaDeviceInfo | null)[]
  >([]);

  useEffect(() => {
    const gameloop = async () => {
      setGamepads([...navigator.getGamepads()]);
      setMediaDevices([...(await navigator.mediaDevices.enumerateDevices())]);

      //console.log(navigator.getGamepads());

      requestAnimationFrame(gameloop);
    };

    gameloop();
  }, []);

  //console.log(gamepads[0]);

  return (
    <div className="App">
      <h2>Gamepads</h2>
      <div className="card-deck">
        {gamepads
          .filter((gp) => !!gp)
          .map((gamepad) => (
            <div className="card">
              <h3>{gamepad?.id}</h3>
              <div>
                Mapping: <b>{gamepad?.mapping}</b>
              </div>
              <h4>Buttons</h4>
              <div style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}>
                {gamepad?.buttons.map((button, i) => (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      background: `radial-gradient(var(--primary) 0%, var(--primary) ${
                        button.value * 100 - 10
                      }%, white ${button.value * 100}%)`,
                      color: button.value === 0 ? "black" : "white",
                      borderRadius: "20px",
                      width: "40px",
                      height: "40px",
                      fontSize: "10px",
                    }}
                  >
                    <div
                      style={{
                        fontWeight: 500,
                      }}
                    >
                      {i}
                    </div>
                    <div
                      style={{ color: button.value !== 0 ? "black" : "unset" }}
                    >
                      {button.value.toFixed(2).replaceAll(".00", "")}
                    </div>
                  </div>
                ))}
              </div>
              <h4>Axes</h4>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "4px",
                }}
              >
                {gamepad?.axes.map((axis, i) => (
                  <>
                    <Slider value={axis} />
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      {axis.toFixed(2)}
                    </div>
                  </>
                ))}
              </div>
              {JSON.stringify({ ...gamepad })}
            </div>
          ))}
      </div>
      <h2>Display info</h2>
      <div className="card" style={{ padding: "32px" }}>
        <table style={{ fontSize: "16px", width: "100%" }}>
          <tr>
            <td>
              <b>Inner Width</b>
            </td>
            <td>{window.innerWidth}</td>
          </tr>
          <tr>
            <td>
              <b>Inner Height</b>
            </td>
            <td>{window.innerHeight}</td>
          </tr>
          <tr>
            <td>
              <b>Outter Height</b>
            </td>
            <td>{window.outerWidth}</td>
          </tr>
          <tr>
            <td>
              <b>Outter Height</b>
            </td>
            <td>{window.outerHeight}</td>
          </tr>
          <tr>
            <td>
              <b>Device pixel ratio</b>
            </td>
            <td>{window.devicePixelRatio}</td>
          </tr>
          <tr>
            <td>
              <b>Bluetooth pair support</b>
            </td>
            <td>
              <button
                disabled={!(navigator as any).bluetooth}
                onClick={() => {
                  try {
                    (navigator as any).bluetooth
                      ?.requestDevice({
                        acceptAllDevices: true,
                      })
                      .catch(() => {});
                  } catch (e) {}
                }}
              >
                Request Bluetooth
              </button>
            </td>
          </tr>
        </table>
      </div>
      <div
        className="card"
        style={{
          marginTop: "24px",
          padding: "24px",
          width: "196px",
        }}
      >
        <FPSMeter />
      </div>
      <h2>Media Devices</h2>
      <button
        style={{ marginBottom: "8px" }}
        onClick={() => {
          try {
            navigator.mediaDevices
              .getUserMedia({ video: true, audio: true })
              .catch(() => {});
          } catch {}
        }}
      >
        Request Media Devices
      </button>
      <div className="card-deck">
        {mediaDevices
          .filter((o) => !!o)
          .map((device) => (
            <div className="card">
              <h3>{device?.label}</h3>
              <div className="subtitle">{device?.kind}</div>
              <div style={{ whiteSpace: "wrap", wordBreak: "break-all" }}>
                <small>{device?.deviceId}</small>
                <br />
                <small>{device?.groupId}</small>
              </div>
            </div>
          ))}
      </div>
      <ScreenDetails />
    </div>
  );
}

export default App;
